// frontend/src/components/ui/Dropzone.tsx
import { DropzoneStyled } from "@/components/styled/dropzoneStyled";
import { Accept } from "react-dropzone";

type DropzoneProps = {
  files: File[] | null;
  setFiles: (value: File[] | null | ((prev: File[] | null) => File[] | null)) => void;
  maxFiles?: number;
  dropZoneText?: string;
  accept?: Accept;
};

export const Dropzone = ({
  files,
  setFiles,
  maxFiles = 1,
  dropZoneText,
  accept,
}: DropzoneProps) => {
  const handleFileChange = (selectedFiles: File[]) => {
    if (!selectedFiles || selectedFiles.length === 0) return;
    setFiles((prevState: File[] | null) => {
      const prev = prevState || [];
      // Only add up to maxFiles
      const combined = [...prev, ...selectedFiles].slice(0, maxFiles);
      return combined;
    });
  };

  const handleRemoveFile = (index: number) => {
    setFiles((prevState: File[] | null) => {
      if (!prevState) return null;
      const newArray = [...prevState];
      newArray.splice(index, 1);
      return newArray.length > 0 ? newArray : null;
    });
  };

  return (
    <DropzoneStyled
      files={files}
      setFiles={setFiles}
      handleFileChange={handleFileChange}
      handleRemoveFile={handleRemoveFile}
      dropZoneText={dropZoneText}
      accept={accept}
      maxFiles={maxFiles}
    />
  );
};
